import { BASE_URL } from "./";
import formurlencoded from "form-urlencoded";

export const accountHomeViewService = {
  getAppliances,
  getAppliance,
  setAppliance,
  getHolidayMode,
  setHolidayMode,
  getDoNotDisturb,
  setDoNotDisturb,
  getTariff,
  setTariff,
};

function getAppliances(user) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  };
  return fetch(
    `${BASE_URL}/list_appliances/?user_id=${user.user_id}`,
    requestOptions
  )
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(response.statusText);
      }

      return response.json();
    })
    .then((detail) => {
      return detail;
    });
}
function getAppliance(user, id) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  };
  return fetch(
    `${BASE_URL}/appliance_settings/?user_id=${user.user_id}&appliance_type_id=${id}`,
    requestOptions
  )
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(response.statusText);
      }

      return response.json();
    })
    .then((detail) => {
      return detail;
    });
}
function setAppliance(user_id, values) {
  const obj = {
    user_id: user_id,
    ...values,
  };

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-CSRFToken": JSON.parse(localStorage.getItem("CSRF")),
    },
    body: formurlencoded(obj),
    credentials: "include",
  };
  return fetch(`${BASE_URL}/appliance_settings/`, requestOptions)
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(response.statusText);
      }

      return response.json();
    })
    .then((detail) => {
      return detail;
    });
}

function getHolidayMode(user) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  };
  return fetch(
    `${BASE_URL}/holiday_mode/?user_id=${user.user_id}`,
    requestOptions
  )
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(response.statusText);
      }

      return response.json();
    })
    .then((detail) => {
      return detail;
    });
}
function setHolidayMode(user_id, values) {
  const obj = {
    user_id: user_id,
    ...values,
  };

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-CSRFToken": JSON.parse(localStorage.getItem("CSRF")),
    },
    body: formurlencoded(obj),
    credentials: "include",
  };
  return fetch(`${BASE_URL}/holiday_mode/`, requestOptions)
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(response.statusText);
      }

      return response.json();
    })
    .then((detail) => {
      return detail;
    });
}
function getDoNotDisturb(user) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  };
  return fetch(
    `${BASE_URL}/no_disturb_mode/?user_id=${user.user_id}`,
    requestOptions
  )
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(response.statusText);
      }

      return response.json();
    })
    .then((detail) => {
      return detail;
    });
}
function setDoNotDisturb(user_id, values) {
  const obj = {
    user_id: user_id,
    ...values,
  };

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-CSRFToken": JSON.parse(localStorage.getItem("CSRF")),
    },
    body: formurlencoded(obj),
    credentials: "include",
  };
  return fetch(`${BASE_URL}/no_disturb_mode/`, requestOptions)
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(response.statusText);
      }

      return response.json();
    })
    .then((detail) => {
      return detail;
    });
}

function handleResponse(response) {
  if (!response.ok) {
    return Promise.reject(response.statusText);
  }

  return response.json();
}
function getTariff(user) {
  const requestOptions = {
    method: "GET",
    // mode: "no-cors",
    headers: {
      "Content-Type": "application/json",
      // "Access-Control-Allow-Origin": "http://localhost:3000/",
      // "X-CSRFToken": localStorage.getItem("CSRF"),
    },
    credentials: "include",
  };
  return fetch(
    `${BASE_URL}/tariff_setting/?user_id=${user.user_id}`,
    requestOptions
  )
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(response.statusText);
      }

      return response.json();
    })
    .then((detail) => {
      return detail;
    });
}
function setTariff(user_id, values) {
  let obj = {
    user_id: user_id,
    tariff: JSON.stringify(values),
  };

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-CSRFToken": JSON.parse(localStorage.getItem("CSRF")),
    },
    body: `user_id=${user_id}&tariff=${JSON.stringify(values)}`,
    credentials: "include",
  };
  return fetch(`${BASE_URL}/tariff_setting/`, requestOptions)
    .then((response) => {
      if (!response.ok) {
        // return response.json();
        return Promise.reject(response.statusText);
      }

      return response.json();
    })
    .then((detail) => {
      return detail;
    });
}
